(function () {
  'use strict';

  function UsoIndevidoVeiculoConfiguration() {
    return {
      templateUrl: `configuracoes/eventos/subpaginas/uso-indevido-veiculo-configuration/uso-indevido-veiculo-configuration.tpl.html`,
      controller: 'UsoIndevidoVeiculoConfigurationCtrl',
      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {}
    };
  }

  angular
    .module('SubpaginasEventos')
    .directive('usoIndevidoVeiculoConfigurationEventos', UsoIndevidoVeiculoConfiguration);
}());
